/**
 * Generate unique IDs for CRM entities
 */
export function generateId(prefix = 'id') {
    return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
}

export function nowIso() {
    return new Date().toISOString();
}
